import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { gatewayRequestAxios } from '../../services/interceptor'
import { GATEWAY_BULK_API_HEALTH_URL } from '../../constants/urls'

const initialState = {
  bulkHealthCheck: {},
  status: 'idle',
  error: null
}

export const fetchBulkHealthCheck = createAsyncThunk('bulkHealthCheck/fetchBulkHealthCheck', async () => {
  const response = await gatewayRequestAxios.get(GATEWAY_BULK_API_HEALTH_URL)
  return response.data
})

export const bulkHealthCheckSlice = createSlice({
  name: 'bulkHealthCheck',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBulkHealthCheck.pending, (state) => {
        state.status = 'loading'
        state.bulkHealthCheck = {}
        state.error = undefined
      })
      .addCase(fetchBulkHealthCheck.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.error = undefined
        state.bulkHealthCheck = action.payload
      })
      .addCase(fetchBulkHealthCheck.rejected, (state, action) => {
        state.status = 'failed'
        state.bulkHealthCheck = {}
        state.error = action.error.message
      })
  }
})

export default bulkHealthCheckSlice.reducer
export const selectBulkHealthCheck = (state) => state.bulkHealthCheck.bulkHealthCheck
export const getBulkHealthCheckStatus = (state) => state.bulkHealthCheck.status
export const getBulkHealthCheckError = (state) => state.bulkHealthCheck.error
